import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-879cc532"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "faq-block"
}
const _hoisted_2 = {
  key: 1,
  class: "insurance-info-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_faq_group = _resolveComponent("faq-group")!
  const _component_text_formatter = _resolveComponent("text-formatter")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_main_container_shell = _resolveComponent("main-container-shell")!

  return (_openBlock(), _createBlock(_component_main_container_shell, { classes: ['container'] }, {
    default: _withCtx(() => [
      (_ctx.hasFaqItems)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frequentlyAskedQuestions, (group) => {
              return (_openBlock(), _createBlock(_component_faq_group, {
                key: group.title,
                group: group
              }, null, 8, ["group"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasInformation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_base_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_text_formatter, { content: _ctx.information }, null, 8, ["content"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}